var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.11304 5H11.9051C14.3271 5 16.0181 6.66904 16.0181 9.06091V15.9391C16.0181 18.331 14.3271 20 11.9051 20H6.11304C3.69102 20 2 18.331 2 15.9391V9.06091C2 6.66904 3.69102 5 6.11304 5ZM19.9583 7.37901C20.3973 7.15566 20.9123 7.17901 21.3313 7.44297C21.7503 7.70591 22.0003 8.16277 22.0003 8.66226V16.3384C22.0003 16.8389 21.7503 17.2947 21.3313 17.5577C21.1023 17.7008 20.8463 17.7739 20.5883 17.7739C20.3733 17.7739 20.1583 17.7232 19.9573 17.6206L18.4763 16.8734C17.9283 16.5953 17.5883 16.0369 17.5883 15.4166V9.58307C17.5883 8.96175 17.9283 8.40337 18.4763 8.12723L19.9583 7.37901Z",
    fill: "#18212C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoDark);
export default __webpack_public_path__ + "static/media/video_dark.0d5fb32a4578f1ccfe159fe0a0950464.svg";
export { ForwardRef as ReactComponent };